import React from 'react'

const IdContext = React.createContext<string>(null!)

export default IdContext
